import './templateTableStyles.scss';

const TemplateTable = ({id, title, headers, rows, onRowsChange, enableActions = false, onNill = false}) => {
  const handleChange = (index, key, value) => {
    const updated = [...rows];
    updated[index][key] = value;
    onRowsChange(id, updated);
  };

  const updateSerialNumbers = rows => rows.map((row, index) => ({...row, sno: (index + 1).toString()}));

  const addRow = () => {
    const emptyRow = Object.fromEntries(headers.map(h => [h.key, '']));
    const updatedRows = updateSerialNumbers([...rows, emptyRow]);
    onRowsChange(id, updatedRows);
  };

  const removeRow = () => {
    if (rows.length > 1) {
      const updatedRows = updateSerialNumbers(rows.slice(0, -1));
      onRowsChange(id, updatedRows);
    }
  };

  const deleteRow = indexToRemove => {
    const updated = rows.filter((_, idx) => idx !== indexToRemove);
    const updatedWithSno = updateSerialNumbers(updated);
    onRowsChange(id, updatedWithSno);
  };

  return (
    <div style={{marginBottom: '20px'}}>
      {title && <h4>{title}</h4>}
      <table className='table_1' style={{width: '100%', borderCollapse: 'collapse', border: '1px solid black'}}>
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header.key} style={{border: '1px solid black', textAlign: 'center'}}>
                {header.label}
              </th>
            ))}
            {enableActions && <th style={{border: '1px solid black', textAlign: 'center'}}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx}>
              {headers.map(header => {
                let currentInputType = header.inputType || 'text';
                let currentOptions = header.options;

                if (header.inputType === 'conditional' && header.conditions && row.parameter) {
                  const condition = header.conditions[row.parameter];
                  if (condition) {
                    currentInputType = condition.type;
                    currentOptions = condition.options;
                  }
                }

                // Special case for 'Date' investigation type
                if (row.investigation === 'Date' && header.key === 'result') {
                  currentInputType = 'date';
                }

                return (
                  <td key={header.key} style={{border: '1px solid black'}}>
                    {currentInputType === 'select' ? (
                      <select value={row[header.key]} onChange={e => handleChange(idx, header.key, e.target.value)} style={{width: '100%', border: 'none'}}>
                        <option value='' disabled>
                          Select
                        </option>
                        {currentOptions?.map(option => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : currentInputType === 'datalist' ? (
                      <>
                        <input list={`${header.key}-options-${idx}`} value={row[header.key]} onChange={e => handleChange(idx, header.key, e.target.value)} style={{width: '100%', border: 'none'}} />
                        <datalist id={`${header.key}-options-${idx}`}>
                          {currentOptions?.map(option => (
                            <option key={option} value={option} />
                          ))}
                        </datalist>
                      </>
                    ) : currentInputType === 'date' ? (
                      <input type='date' value={row[header.key]} onChange={e => handleChange(idx, header.key, e.target.value)} style={{width: '100%', border: 'none'}} />
                    ) : (
                      <input
                        type='text'
                        value={row[header.key]}
                        onChange={e => handleChange(idx, header.key, e.target.value)}
                        style={{
                          width: '100%',
                          border: 'none',
                          boxSizing: 'border-box',
                          padding: '4px',
                          font: 'inherit',
                          whiteSpace: 'pre-line'
                        }}
                      />
                    )}
                  </td>
                );
              })}
              {enableActions && (
                <td style={{border: '1px solid black', textAlign: 'center'}}>
                  <button type='button' className='btn btn-danger btn-sm' onClick={() => deleteRow(idx)} disabled={rows.length <= 1}>
                    Delete
                  </button>
                </td>
              )}
            </tr>
          ))}
          <tr>
            <td colSpan={headers.length + (enableActions ? 1 : 0)} style={{textAlign: 'right'}}>
              <button type='button' onClick={addRow} className='btn btn-info m-1'>
                Add
              </button>
              {/* Uncomment below if remove button is needed */}
              {/* <button type='button' onClick={removeRow} className='btn btn-info m-1' disabled={rows.length <= 1}>
                Remove
              </button> */}
              {onNill && (
                <button type='button' onClick={() => onNill(id)} className='btn btn-warning m-1'>
                  Nill
                </button>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TemplateTable;
